import { Box } from "@mui/material";
import React from "react";

interface IBatchTabPanel {
    value: number;
    index: number;
    children: React.ReactNode;
}

export const BatchTabPanel : React.FC<IBatchTabPanel> = ({
    value,
    index,
    children
}) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
        >
            {value === index && <Box marginTop="16px">{children}</Box>}
        </div>
    )
}